import { isAgent } from '../../../helpers';

export const agentGateway = `/agent`;
export const customerGateway = `/gateway`;

export const targetGateway = () =>  isAgent() ? agentGateway : customerGateway;

export const homeGateway = `/home`;
export const homeService = `${homeGateway}/applied_home_quotes`;
export const homeDocumentService = `/home/applied_home_documents`;
export const homePromoCode = `/home/promo`;
export const homePromoCodeValidate = `${homePromoCode}/validate?promoCode=`;

export const motorGateway = `/motor`;
export const motorService = `${motorGateway}/motor_quotes`;

export const travelGateway = `/travel`;
export const travelService = `/travel/travel_quotes`;

export const profileGateway = '/profile';
export const profileService = '/profile';

export const homeCreateQuote = `${homeGateway}/create_quote`;
export const homeBind = (`${homeGateway}/bind_upload`);
export const homeBindStatus = (`${homeGateway}/bind_status`);
export const homeLatest = (`${homeGateway}/latest`);
export const homeLatestPolicyCode = `${homeLatest}/policy_code`;
export const homeRenewalRetrieve = (`/home_renewal/retrieve`);
export const homeRenewalBind = (`/home_renewal/bind_upload`);
export const homeRenewalDocuments = `${homeDocumentService}/renewal/summary`;
export const homeDocumentsSummary = `${homeDocumentService}/summary`;
export const homeLatestSearch = `${homeGateway}/search/latest_quotes`;
export const agentLatestHomeQuotesSearch = `${agentGateway}${homeGateway}/latest_quotes_search`;
export const agentHomeLatestUsers = `${agentGateway}${homeGateway}/latest_quotes_users`;
export const agentVerifyPortfolioCode = `${agentGateway}${homeGateway}/verify/portfolio`;
export const homeSurvey = (`${homeGateway}/surveys`);

export const agentMatchGateway = `${agentGateway}${homeGateway}/match`;
export const agentGetPortfolioCodes = `${agentMatchGateway}/search`;
export const agentMatchPortfolioCode = `${agentMatchGateway}/match`;
export const agentUnmatchPortfolioCode = `${agentMatchGateway}/unmatch`;

export const homeAddressLookup = `${homeService}/address`;
export const homeAddressLookupManual = `${homeService}/manual_address`;
export const homeAddressCodeList = `${homeAddressLookup}/code_list`;
export const homeMarketing = `/home/marketingConsent`;
export const homeMarketingAppendPolicy = `${homeMarketing}/append`;
export const homeItb = `${homeGateway}/itb`;
export const homeItbRegister = `${homeItb}/register`;
export const homeItbComplete = `${homeService}/update_bind_status`;

export const motorQuotesBind = (`${motorGateway}/bind`);
export const motorQuotesLatest = `${motorService}/latest`;
export const motorLatestSearch = `${motorGateway}/search/latest_quotes`;
export const motorQuotesContacted = `${motorService}/contacted`;
export const motorDocuments = `${motorService}/documents`;
export const motorVehicleLookup = `${motorGateway}/resources/vehicle/lookup`;
export const motorVehicleLookupManual = `${motorVehicleLookup}/manual`;
export const motorSurvey = `${motorGateway}/surveys`;

export const travelDocuments = `${customerGateway}${travelGateway}/documents`;
export const travelQuotesCreateQuote = (`${travelGateway}/create_quote`);
export const travelQuotesBind = (`${travelGateway}/bind`);
export const travelQuotesLatest = (`${travelGateway}/latest`);
export const getTravelParams = `${travelGateway}/quote_parameters`;

export const createProfile = `${profileGateway}/create`;
export const agentCreateAndMatch = `${agentGateway}${profileGateway}/create_match`
export const agentCreateProfile = `${agentGateway}${profileGateway}/create/user`;
export const agentProfileEmailSearch = `${agentGateway}${profileGateway}/search/email`;
export const custVerifyProfileEmailSearch = `${profileGateway}${profileService}/search/email`;
export const getProfileDetails = (`${profileGateway}`);
export const updateBranch = `${agentGateway}${profileGateway}/branch`;
export const getBranch = `${updateBranch}`;
export const getAllBranches = `${getBranch}es`;

export const userTempQuote = `${customerGateway}${profileGateway}/tempQuote`;

export const updateNumber = `/update_phone_number`;
export const featureFlag = '/feature';
export const verified = '/verified';
export const getUsersEndpoint = '/users';
